export { SuiSidebarModule, SidebarDirection, SidebarTransition } from "./index";
//# sourceMappingURL=public.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/modules/sidebar/public.js
// module id = 1122
// module chunks = 0